/** The three-rule navigation mark (omega-summon.js MARK), used by the sigil and the hamburger. */
export function SigilMark() {
  return (
    <svg viewBox="0 0 28 18.4" width="28" height="18.4" aria-hidden="true" focusable="false">
      <line x1="1" y1="1" x2="27" y2="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="1" y1="9.2" x2="19" y2="9.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <line x1="1" y1="17.4" x2="11" y2="17.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
